import { Row } from "components/Layout";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { axiosInstance } from "services/api";
import { lsc } from "services/availableLanguages";

const Preview = () => {
    const endPoints = window.endPoints;
	const { id } = useParams();
	const { i18n } = useTranslation()
	const [currentHtml, setCurrentHtml] = useState(null);
	const [title, setTitle] = useState("")

	useEffect(() => {
		const getTemplate = async () => {
			try {
				const { data } = await axiosInstance.get(
					`${endPoints.api.urlPublic}preview/${id}`,
				);
				setCurrentHtml(data.html);
				setTitle(data.title)
				document.documentElement.style.setProperty('--bgColor', data.colorBackground)
				document.documentElement.style.setProperty('--gray', data.colorFont)
				document.documentElement.style.setProperty('--dk-surface', data.colorFont)
				const customCssLink = document.getElementById("headLinkCustomCss_portal")

				const lang = lsc(i18n.language)
				customCssLink.setAttribute("href", window.endPoints.api.baseApi + "public/preview/" + id + "/customCss?lang=" + lang);
			} catch (e) {
				console.error(e);
			}
		};

		getTemplate();
	}, []);

	if (!currentHtml) return null;

	return (
		<div>
			<header className="pvt-main-header">
				<Row>
					<h1 className="pvt-d-block pvt-f-left">{title}</h1>
				</Row>
			</header>
			<div dangerouslySetInnerHTML={{ __html: currentHtml }} />
		</div>
	);
};

export default Preview;
